// /pdf/sections/indicators.js
export function renderIndicators(doc, data, startY, iconsMap) {
  let y = startY+130;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("3. Indicators", 14, y);
  y += 10;

  // Define custom titles for each section
  const sectionTitles = {
    CWIS: "City-Wide Inclusive Sanitation (CWIS)",
    "Solid Waste Management (SWM)": "Solid Waste Management (SWM)"
  };

  Object.keys(data).forEach((sectionKey) => {
    // Section title
    const title = sectionTitles[sectionKey] || sectionKey;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(title, 14, y);
    y += 8;

    // Indicators
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);

    data[sectionKey].forEach((item) => {
      // Draw icon if available
      // if (item.icon && iconsMap && iconsMap[item.icon]) {
      //   const iconSize = 6;
      //   doc.addImage(iconsMap[item.icon], "PNG", 14, y - 4, iconSize, iconSize);
      // }

      // Indicator text
      doc.text(item.indicator, 16, y);

      // Value at the right
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.text(item.value, pageWidth - 15, y, { align: "right" });

      y += 8;
    });

    y += 6; // space between sections
  });

  return y;
}
